import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateNotifications } from "web_myplann/Api/Notifications/notificatioKeys";
import { patchNotificationsIdReadV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useNotificationMarksAsReadMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(notificationId: number) => patchNotificationsIdReadV2(notificationId),
			{ skipToastFor: true },
		),
		onSettled: () => {
			invalidateNotifications(queryClient);
		},
	});
};
